var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductosCreados(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4630",
    "data-name": "Rect\\xE1ngulo 4630",
    width: 48,
    height: 48,
    transform: "translate(159 6576)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_21",
    "data-name": "Enmascarar grupo 21",
    transform: "translate(-159 -6576)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10029",
    "data-name": "Grupo 10029",
    transform: "translate(-1418.88 6390.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19246",
    "data-name": "Trazado 19246",
    d: "M1586.5,221.659h30.227a1.512,1.512,0,0,0,1.511-1.511V203.523a3.022,3.022,0,0,0-3.022-3.023h-22.67a3.022,3.022,0,0,0-3.023,3.023v13.6",
    transform: "translate(1.023 3.579)",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19247",
    "data-name": "Trazado 19247",
    d: "M1590.545,207.1v15.113a3.023,3.023,0,0,1-3.023,3.023h0a3.022,3.022,0,0,1-3.023-3.023v-27.2a1.512,1.512,0,0,1,1.511-1.511h6.321a1.511,1.511,0,0,1,1.415.981l.966,2.572a1.511,1.511,0,0,0,1.415.981h17.089a3.022,3.022,0,0,1,3.023,3.023v3.023h-22.67A3.022,3.022,0,0,0,1590.545,207.1Z",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductosCreados);
export default __webpack_public_path__ + "static/media/productosCreados.56cfdb8e2f19449a0751d6029d88cb1b.svg";
export { ForwardRef as ReactComponent };